import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    Modal, Button, Input, Icon,
} from 'antd';
import { loginRequest } from './redux/actions/account_actions/login.actions';
import { validation_rules } from '../../shared/validation_rules';

export default connect(state => ({
    login: state.App.App_content.user.login,
    loading: state.App.Login_form.loading,
}), null)(class CheckUserActivityModal extends Component {
    state = {
        password: '',
        passwordVisibility: false,
    };

    handleChange = (name, value) => this.setState({ [name]: value });

    handleOk = () => {
        this.props.dispatch(loginRequest({ login: this.props.login, password: this.state.password, status: 'afterConfirm' }));
        this.props.dispatch({ type: 'RESET_LEADS' });
        this.setState({ password: '' });
    };

    showPassword = () => this.setState({ passwordVisibility: !this.state.passwordVisibility });

    render() {
        const { password, passwordVisibility } = this.state; const
            { password: passwordValidation } = validation_rules;
        return (
            <Modal
                title="Your session has become inactive..."
                visible
                closable={false}
                maskClosable={false}
                footer={[
                    <Button
                        key="submit"
                        type="primary"
                        loading={this.props.loading}
                        disabled={!(!passwordValidation(password) && password)}
                        onClick={this.handleOk}
                    >
                        Login
                    </Button>,
                ]}
            >

                {/* WebkitTextSecurity: !passwordVisibility ? 'disc' : 'none' */}
                <div style={{ display: 'flex' }}>
                    <span>Re-enter Password: </span>
                    <Input
                        type={(password && !passwordVisibility) ? 'password' : 'text'}
                        onPressEnter={this.handleOk}
                        value={password}
                        maxLength={20}
                        style={{ width: '55%', margin: '-3px 0 0 25px' }}
                        placeholder="Password"
                        suffix={<Icon type={!passwordVisibility ? 'eye' : 'eye-invisible'} onClick={this.showPassword} style={{ color: 'rgba(0,0,0,.25)' }} />}
                        onChange={event => this.handleChange('password', event.target.value)}
                    />
                </div>
                <div className="validationPasswordError">{password && passwordValidation(password)}</div>
            </Modal>
        );
    }
});



// WEBPACK FOOTER //
// ./src/modules/App/CheckUserActivityModal.js